import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicLanguage } from '../contexts/PublicLanguageContext';
import brandLogo from '../assets/brand/logo.png';

const PublicFooter = () => {
  const { t } = usePublicLanguage();

  return (
    <footer className="public-note-footer-wrap pt-12 sm:pt-14 pb-5 sm:pb-6 px-3 sm:px-5 lg:px-8">
      <div className="mx-auto max-w-[1680px]">
        <div className="public-note-footer-sheet rounded-3xl p-7 sm:p-9 lg:p-11">
          <span className="public-note-footer-fold" aria-hidden="true" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-9 lg:gap-10">
            <div className="xl:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <img
                  src={brandLogo}
                  alt="Candio logo"
                  className="h-8 w-8 object-contain"
                />
                <span className="text-xl font-bold public-note-footer-brand">Candio</span>
              </div>
              <p className="public-note-footer-slogan">{t('brand.slogan')}</p>
            </div>

            <div>
              <h3 className="public-note-footer-heading">{t('home.footer.product.title')}</h3>
              <ul className="space-y-2 public-note-footer-links">
                <li><Link to="/fonctionnalites" className="public-note-footer-link">{t('home.footer.product.features')}</Link></li>
                <li><Link to="/tarification" className="public-note-footer-link">{t('home.footer.product.pricing')}</Link></li>
                <li><Link to="/contact" className="public-note-footer-link">{t('home.footer.product.api')}</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="public-note-footer-heading">{t('home.footer.company.title')}</h3>
              <ul className="space-y-2 public-note-footer-links">
                <li><Link to="/qui-sommes-nous" className="public-note-footer-link">{t('home.footer.company.about')}</Link></li>
                <li><Link to="/contact" className="public-note-footer-link">{t('home.footer.company.contact')}</Link></li>
                <li><Link to="/contact" className="public-note-footer-link">{t('home.footer.company.careers')}</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="public-note-footer-heading">{t('home.footer.support.title')}</h3>
              <ul className="space-y-2 public-note-footer-links">
                <li><Link to="/contact" className="public-note-footer-link">{t('home.footer.support.documentation')}</Link></li>
                <li><Link to="/contact" className="public-note-footer-link">{t('home.footer.support.guides')}</Link></li>
                <li><Link to="/securite-confidentialite" className="public-note-footer-link">{t('home.footer.support.security')}</Link></li>
              </ul>
            </div>
          </div>

          <div className="public-note-footer-copy mt-9 pt-6 text-center">
            <p dangerouslySetInnerHTML={{ __html: t('home.footer.copyright') }} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
